import { GameRule } from './UI/GameRule'
import { Ga4EventType, ga4Info, GodziDropDashBoard } from '@slot-nx/core'
import { useGodziDropStore } from '../domain/godzi/store/godziDropStore'

export const GameUI = () => {
  const isShowDashboard = useGodziDropStore(state => state.isShowDashboard)

  return (
    <>
      <GameRule />
      <GodziDropDashBoard
        onClose={() => {
          ga4Info.addEvent(Ga4EventType.close_promotion_panel)
          useGodziDropStore.setState({ isShowDashboard: false })
        }}
        isShowDashboard={isShowDashboard}
      />
    </>
  )
}
